var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoCheck = function SvgIcoCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76001 8.71394L8.47549 11.4192L12.48 6.61922",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};
export default SvgIcoCheck;